
export const matchedPersonField: string = 'matched_person';

export interface PersonalInfoFields {
	designation_salutation: string;
	first_name: string;
	middle_name: string;
	last_name: string;
	suffix: string;
	known_as: string;
	gender: string;
	gender_identity: string[];
	gender_identity_other: string;
	date_of_birth: string;
	tax_id: string;
}

export interface PersonFields {
	first_name: string | boolean;
	middle_name: string | boolean;
	last_name: string | boolean;
	suffix: string | boolean;
	known_as?: string | boolean;
	gender: string | boolean;
	gender_identity: string[] | boolean;
	gender_identity_other: string | boolean;
	date_of_birth: string | boolean;
	tax_id: string | boolean;
}

export interface MaritalStatusFields {
	marital_status: string;
	marital_status_effective_date: string;
}

export interface MailingAddressFields {
	mailing_address_1: string;
	mailing_address_2: string;
	mailing_address_3: string;
	mailing_country: string;
	mailing_city: string;
	mailing_state: string;
	mailing_postal_code: string;
}

export interface AddressFields {
	country: string | boolean;
	address1: string | boolean;
	address2: string | boolean;
	address3?: string | boolean;
	city: string | boolean;
	state: string | boolean;
	province?: string | boolean;
	postalCode: string | boolean;
}

export interface PhoneFields {
	business_phone_country_code: string;
	business_phone_area_code: string;
	business_phone_number: string;
	business_phone_formated: string;
	business_phone_extension: string;

	home_phone_country_code: string;
	home_phone_area_code: string;
	home_phone_number: string;
	home_phone_formated: string;
	home_phone_extension: string;

	mobile_phone_country_code: string;
	mobile_phone_area_code: string;
	mobile_phone_number: string;
	mobile_phone_formated: string;
	mobile_phone_extension: string;
}

export interface ContactInformationFields {
	business_phone_country_code: string;
	business_phone_area_code: string;
	business_phone_number: string;
	business_phone_formatted: string;
	business_phone_extension: string;

	fax_phone_country_code: string;
	fax_phone_formatted: string;
	fax_phone_extension: string;

	business_email_address: string;
	website_url: string;
}

export interface EmailFields {
	office_email_address: string;
	personal_email_address: string;
}

export const MailingAddressFieldNames: AddressFields = {
	country: 'mailing_country',
	address1: 'mailing_address_1',
	address2: 'mailing_address_2',
	address3: 'mailing_address_3',
	city: 'mailing_city',
	state: 'mailing_state',
	postalCode: 'mailing_postal_code',
};

export const InstitutionMailingAddressFieldNames: AddressFields = {
	country: 'billing_country',
	address1: 'billing_address_1',
	address2: 'billing_address_2',
	address3: 'billing_address_3',
	city: 'billing_city',
	state: 'billing_state',
	postalCode: 'billing_postal_code',
};

export const InstitutionPhysicalAddressFieldNames: AddressFields = {
	country: 'physical_country',
	address1: 'physical_address_1',
	address2: 'physical_address_2',
	address3: 'physical_address_3',
	city: 'physical_city',
	state: 'physical_state',
	postalCode: 'physical_postal_code',
};

export const InstitutionAddRequestMailingAddressFieldNames: AddressFields = {
	country: 'mail_country',
	address1: 'mail_address1',
	address2: 'mail_address2',
	address3: 'mail_address3',
	city: 'mail_city',
	state: 'mail_state',
	postalCode: 'mail_postal_code',
};

export const InstitutionAddRequestPhysicalAddressFieldNames: AddressFields = {
	country: 'street_country',
	address1: 'street_address1',
	address2: 'street_address2',
	address3: 'street_address3',
	city: 'street_city',
	state: 'street_state',
	postalCode: 'street_postal_code',
};

export const clergyBioAddressFieldNames: AddressFields = {
	country: 'country',
	address1: 'address1',
	address2: 'address2',
	address3: 'street_address3',
	city: 'city',
	state: 'state',
	postalCode: 'postalCode',
};


export const InstitutionAddRequestContactInformationFields: ContactInformationFields = {
	business_phone_country_code: 'office_country_code',
	business_phone_area_code: 'office_area_code',
	business_phone_number: 'office_phone',
	business_phone_formatted: 'office_phone_formatted',
	business_phone_extension: 'office_ext',
	fax_phone_country_code: 'fax_country_code',
	fax_phone_formatted: 'fax_formatted',
	fax_phone_extension: 'fax_ext',
	business_email_address: 'email',
	website_url: 'website',
};

export enum FormTypes {
	PERSONAL_INFO = 'personal_info',
	MARITAL_STATUS = 'marital_status',
	MARITAL_STATUS_SPOUSE = 'marital_status_spouse',

	SINGLE_MARITAL_STATUS = 'single_marital_status',
	POST_DEPENDENT = 'post_dependent',
	PATCH_DEPENDENT = 'patch_dependent',
	MAP_PERSONAL_INFO = 'map_personal_info',
	MAP_MARITAL_STATUS = 'map_marital_status',
	MAP_MARITAL_STATUS_SPOUSE = 'map_marital_status_spouse',

	MAP_POST_DEPENDENT = 'map_post_dependent',
	MAP_PATCH_DEPENDENT = 'map_patch_dependent',
	SCHEDULED_PAYMENT = 'scheduled_payment',
	ADD_UNPAID_LEAVE = 'add_unpaid_leave',
	COMPENSATION = 'compensation',
	SCHEDULED_HOURS = 'scheduled_hours',
	STIP_POSITION = 'stip_position',
	NON_STIP_POSITION = 'non_stip_position',
	INSTITUTION_DETAILS = 'institution_details',
	INSTITUTION_ADD_REQUEST_SUBMITTED = 'institution_add_request_submitted',
	INSTITUTION_REMOVE_REQUEST_SUBMITTED = 'institution_remove_request_submitted',
	INSTITUTION_REMOVE_REQUEST_ALREADY_SUBMITTED = 'institution_remove_request_already_submitted',
	INSTITUTION_SURVEY = 'institution_survey',
	STIP_NEW_HIRE = 'stip_new_hire',
	NON_STIP_NEW_HIRE = 'non_stip_new_hire',

	PENSION_ENROLLMENT = 'PENSION_ENROLLMENT',
	TERMINATION = 'TERMINATION',

	GENERIC_DOC_UPLOAD = 'generic_doc_upload',

	PERSON_DOC_UPLOAD_SUCCESS = 'person_doc_upload_success',
	MARITAL_STATUS_DOC_UPLOAD_SUCCESS = 'marital_status_doc_upload_success',

	AE_SPOUSE_UPDATE_SUCCESS = 'ae_spouse_update_success',
	NEW_HIRE_SPOUSE_UPDATE_SUCCESS = 'new_hire_spouse_update_success',
	NEW_HIRE_SPOUSE_UPDATE_SUCCESS_WITH_WARNING = 'new_hire_spouse_update_success_with_warning',
	RETIREE_SUCCESS = 'retiree_success',
	MAP_MARITAL_STATUS_DOC_UPLOAD_SUCCESS = 'map_marital_status_doc_upload_success',
	MAP_MARITAL_STATUS_WIDOW_SUCCESS = 'map_marital_status_widow_success',
	MARITAL_STATUS_WIDOW_SUCCESS = 'marital_status_widow_success',
	BENEFIT_SURVEY_SUCCESS = 'benefit_survey_success',
	BENEFIT_SURVEY_SUCCESS_NO_CHANGE = 'benefit_survey_success_no_change',

	BENEFIT_SURVEY = 'BENEFIT_SURVEY',

	CLERGY_BIO_PERSON_UPDATE = 'clergy_bio_person_update',
	CLERGY_BIO_CHURCH_REPORTING_UPDATE = 'clergy_bio_church_reporting_update',
	CLERGY_BIO_RELATIONSHIP_UPDATE = 'clergy_bio_relationship_update',
	CLERGY_BIO_EDUCATION_UPDATE = 'clergy_bio_education_update',
	CLERGY_BIO_MINISTRY_UPDATE = 'clergy_bio_ministry_update',
	CLERGY_BIO_PROFESSIONAL_UPDATE = 'clergy_bio_professional_update',

	NEWHIRE_PENSION_ENROLLMENT = 'new_hire_pension_enrollment',
	BENEFICIARY_CREATE = 'beneficiary_create',
	BENEFICIARY_UPDATE_CPF_LIFE = 'beneficiary_update_cpf_life',
	BENEFICIARY_UPDATE_PRERETIREMENT = 'beneficiary_update_preretirement',
	BENEFICIARY_UPDATE_LAY_LUMP_SUM = 'beneficiary_update_layLumpSum',
	NEW_CLERGY_ENROLLED = 'NEW_CLERGY_ENROLLED',
	ESTABLISH_DOMESTIC_PARTNER = 'ESTABLISH_DOMESTIC_PARTNER',
	DOMESTIC_PARTNER_UPDATE = 'domestic_partner_update',
	MAP_DOMESTIC_PARTNER = 'map_domestic_partner',
	MAP_DOMESTIC_PARTNER_DISSOLUTION = 'map_domestic_partner_dissolution',
	MAP_DOMESTIC_PARTNER_DISSOLUTION_30_PLUS = 'map_domestic_partner_dissolution_30_plus',
	DOMESTIC_PARTNER_DEATH = 'domestic_partner_death',
	MAP_DOMESTIC_PARTNER_DEATH = 'map_domestic_partner_death',
	DOMESTIC_PARTNER_DEATH_WARNING = 'domestic_partner_death_warning',
	MAP_DOMESTIC_PARTNER_DEATH_WARNING = 'map_domestic_partner_death_warning',
	LIFE_EVENT = 'life_event',
	LIFE_EVENT_30_PLUS = 'life_event_30_plus',
	SCHEDULED_HOURS_BELOW_1000 = 'scheduled_hours_below_1000',
	IN_PROGRESS_MID_YEAR_WARNING = 'in_progress_mid_year_warning',

	DEATH_OF_CHILD = 'death_of_child',
	MAP_DEATH_OF_CHILD = 'map_death_of_child',
	HAVE_SPOUSE_WARNING = 'have_spouse_warning',
	HAVE_DOMESTIC_PARTNER_WARNING = 'have_domestic_partner_warning',

	ADOPT_INSTITUTION_PLAN_RSVP = 'ADOPT_INSTITUTION_PLAN_RSVP',
	ADOPT_INSTITUTION_PLAN_LAY_DC = 'ADOPT_INSTITUTION_PLAN_LAY_DC',
	MARITAL_EVENT_30_PLUS = 'marital_event_30_plus',
	in_progress_mid_year_warning_marital_event = 'in_progress_mid_year_warning_marital_event',
	LEGAL_SEPERATION = 'legal_seperation',
	MAP_LEGAL_SEPERATION = 'map_legal_seperation',
	CIC_OPT_IN_SUCCESS = 'opt_in_success',

}